<template>
  <div>
    <div class="card mb-2">
      <div class="card-header bg-primary text-white font-weight-bold">
        Reviews Assigned By Me
      </div>
        <LoadingSpinner v-if="loading" message="" size='1x' />
        <p v-else-if="!entities || entities.length === 0">
        No Reviews have been assigned by you
        </p>
        <template v-else>
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">
                  <span class='search-result-header'>Item ID</span>
                </th>
                <th scope="col">
                  <span class='search-result-header'>Status</span>
                </th>
                <th scope="col">
                  <span class='search-result-header'>Reviewer</span>
                </th>
                <th scope="col">
                  <span class='search-result-header'>Project ID</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="review in visibleReviews">
                <tr
                  v-bind:key="review.id"
                  class="list-table-text">
                    <td :id="'review-' + review.id">
                      <router-link
                        :to="{ name: `project${checkParentType(review)}`, params: {
                        project_id: review.primaryProjectId,
                        id: review.parentId}}"
                        class="view-link"
                        >
                        {{ formatIdString(review) }}
                      </router-link>
                      <b-tooltip :target="'review-' + review.id">
                      {{review.instructions === null ? 'No instructions provided' : review.instructions}}
                    </b-Tooltip>
                    </td>
                    <td>
                      {{ getReviewStatusName(review.reviewStatusId) || 'None' }}
                    </td>
                    <td>
                      {{ review.assigneeName }}
                    </td>
                    <td :id="'my-review-proj' + review.id">
                      {{ review.primaryProjectId }}
                      <b-tooltip :target="'my-review-proj' + review.id">
                        {{review.projectName === null ? 'N/A' : review.projectName}}
                      </b-Tooltip>
                    </td>
                </tr>
              </template>
            </tbody>
          </table>
        </template>
    </div>
    <PaginationControls
      :orderedEntities="entities"
      :initialPageSize="initialPageSize"
      :pageSize="pageSize"
      :pageSizeOptions="pageSizeOptions"
      :currentPage="currentPage"
      :firstVisibleEntry="firstVisibleEntry"
      :lastVisibleEntry="lastVisibleEntry"
      :rows="rows"
      @update-current-page="updateCurrentPage"
      @update-page-size="updatePageSize">
    </PaginationControls>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { LookupModules } from '@/store/moduleConfig';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import Pagination from '@/mixins/Pagination';
import PaginationControls from '@/components/common/PaginationControls.vue';

export default {
  name: 'MyReviewsAssigned',
  components: {
    LoadingSpinner,
    PaginationControls,
  },
  props: {
    entities: Array,
    entityName: String,
    loading: Boolean,
    selectedType: String,
    formatIdString: Function,
  },
  data() {
    return {
      pageSize: 100,
      currentPage: 1,
      entitiesWithoutWithdrawn: this.entities.filter(entity => entity.reviewStatusId !== 4),
    };
  },
  mixins: [Pagination],
  mounted() {
    // dispatch actions to populate vuex state for this page
    this.$store.dispatch(`${LookupModules.SERVICE_CATEGORIES.namespace}/fetchOptions`,
      LookupModules.SERVICE_CATEGORIES.url);
    this.$store.dispatch(`${LookupModules.REVIEW_STATUSES.namespace}/fetchOptions`,
      LookupModules.REVIEW_STATUSES.url);
  },
  computed: {
    ...mapGetters(LookupModules.REVIEW_STATUSES.namespace, {
      reviewStatuses: 'getActiveOptions',
    }),
    rows() {
      return !this.entitiesWithoutWithdrawn ? 0 : this.entitiesWithoutWithdrawn.length;
    },
    visibleReviews() {
      // sort descending by openDate and ascending by serviceId
      return this.entitiesWithoutWithdrawn
        .slice(0)
        .sort((a, b) => {
          if (a.reviewStatusId === 1 || b.reviewStatusId === 1) {
            return a.reviewStatusId - b.reviewStatusId || moment(b.openDate).format('YYYYMMDD')
              - moment(a.openDate).format('YYYYMMDD');
          }
          if (!a.closeDate) return 1;
          if (!b.closeDate) return -1;
          return moment(b.closeDate).format('YYYYMMDD') - moment(a.closeDate).format('YYYYMMDD')
            || a.parentId - b.parentId;
        })
        .slice(
          ((this.currentPage - 1) * this.pageSize),
          (this.currentPage * this.pageSize),
        );
    },
  },
  methods: {
    checkParentType(review) {
      if (review.instrumentId) {
        return 'Instrument';
      }
      return 'Service';
    },
    getReviewStatusName(id) {
      const reviewStatus = this.reviewStatuses.filter(p => p.id === id)[0];
      return reviewStatus ? reviewStatus.name : 'None';
    },
  },
};
</script>
